// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		styleScrollToTop: 'style2',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: true,
		breakpointMobile: '749',
    filterTreeMobileStyle: 'style3'
	},
};

(function() {
	BoostPFS.inject(this);

	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var itemImagesHtml = `
			<div class="media media--transparent media--square media--scale">
				<img
					srcset="${ Utils.getFeaturedImage(images, 'x150') } 150w,
							${ Utils.getFeaturedImage(images, 'x200') } 200w,
							${ Utils.getFeaturedImage(images, 'x250') } 250w,
							${ Utils.getFeaturedImage(images, 'x300') } 300w,
							${ Utils.getFeaturedImage(images, 'x350') } 350w,
							${ Utils.getFeaturedImage(images, 'x450') } 450w,
							${ Utils.getFeaturedImage(images, 'x650') } 650w,"
					sizes="
						(max-width: 767px) 717px,
						(max-width: 989px) 367px,
						287px
					"
					loading="lazy"
					alt="${data.title}"
				>
			</div>
		`;

		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = (!data.tags.includes('Hide Price')) ? buildPrice(data, onSale, priceVaries) : '';
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		// Add Colors
		var colorsHTML = buildColors(data);
		itemHtml = itemHtml.replace(/{{itemColors}}/g, colorsHTML);

		if(typeof Utils.compileShopifyProductVariables == 'function'){
			itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
        }

        if(typeof Utils.compileShopifyProductMetafield == 'function'){
			itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
        }

		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if(typeof Utils.compileShopifyProductVariables == 'function'){
			itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
        }

        if(typeof Utils.compileShopifyProductMetafield == 'function'){
			itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
        }

		return itemHtml;
	}

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function handleize (str) {
		str = str.toLowerCase();
		var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
		// For the old browsers
		for (var i = 0; i < toReplace.length; ++i) {
			str = str.replace(toReplace[i], "");
		}
		str = str.replace(/\W+/g, "-");
		if (str.charAt(str.length - 1) == "-") {
			str = str.replace(/-+\z/, "");
		}
		if (str.charAt(0) == "-") {
			str = str.replace(/\A-+/, "");
		}
		return str
	};

	function buildColors(data) {
		let html = '';
		data.options_with_values.forEach((o, i) => {
			if (o.name == 'color') {
				html += '<div class="color-container">';
				var swatchStyle = '';

				for(var x = 0, all = data.tags.length; x < all; x++){
					if((data.tags[x]).indexOf('swatch:') !== -1){
						swatchStyle = '-' + data.tags[x].replace('swatch:','').trim();
						break;
					}
				}

				o.values.forEach((v, i2) => {
					if (i2 < 5) {
						var va = data.variants.find(variant => variant.option_color == v.title);
						let value = v.title.replace(/ /g, '').toLowerCase();
						let img = data.images_info.find(image => image.src.toLowerCase().includes(value) || (image.alt && image.alt.replace(/ /g, '').toLowerCase().includes(value)));
						let swatch = 'color-' + handleize(va.option_color) + swatchStyle + '.' + boostPFSAppConfig.general.swatch_extension;
						let swatchImg = (boostPFSAppConfig.general.file_url).replace('?',swatch + '?');
						if (!img) {
							if(data.images_info.length > 0){
								img = data.images_info[0].src;
							}
						} else {
							img = img.src;
						}
						html += `
							<div class="swatch-container">
								<img class="swatch" loading="lazy" data-url="${va ? '/products/' + data.handle + '?variant=' + va.id : '/products/' + data.handle}"
								data-srcset="${ Utils.optimizeImage(img, '150x')} 150w,
									${Utils.optimizeImage(img, '200x')} 200w,
									${Utils.optimizeImage(img, '250x')} 250w,
									${Utils.optimizeImage(img, '300x')} 300w,
									${Utils.optimizeImage(img, '350x')} 350w,
									${Utils.optimizeImage(img, '450x')} 450w,
									${Utils.optimizeImage(img, '650x') } 650w,"
								src="${Utils.optimizeImage(swatchImg, '48x48_crop_center')}">
								<div class="tooltip">${v.title}</div>
							</div>
						`;
					}
					if (i2 == 5) {
						html += `
							<span class="swatch-end"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus"><use xlink:href="#icon-plus" /></svg> ${(o.values.length - 5)}</span>
						`;
					}
				});
				html += '</div>';
			}
		});
		return html;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '';
		var comparePriceVaries = data.compare_at_price_min != data.compare_at_price_max;
		var priceVariesClass = !priceVaries && comparePriceVaries ? ' price--compare-price-hidden' : '',
			variant = data.variants[0],
			unitPriceMeasurementClass = '';
		if (variant.hasOwnProperty('unit_price_measurement')) {
			unitPriceMeasurementClass = ' price--unit-available';
		}
		priceHtml += '<dl class="price price--listing' + priceVariesClass + unitPriceMeasurementClass + '" data-price>';
		if (boostPFSConfig.custom.hasOwnProperty('vendor_enable') && boostPFSConfig.custom.vendor_enable == true) {
			priceHtml += '<div class="price__vendor price__vendor--listing">';
		}
		if (data.compare_at_price_min > data.price_min) {
			priceHtml += '<span class="price__compare">';
			priceHtml += Utils.formatMoney(data.compare_at_price_min);
			priceHtml += '</span>';
		}
		priceHtml += '<span class="price__regular">';
		if (priceVaries) {
			priceHtml += Utils.formatMoney(data.price_min) + ' - ' + Utils.formatMoney(data.price_max);
		} else {
			priceHtml += Utils.formatMoney(data.price_min);
		}
		priceHtml += '</span>';
		priceHtml += '<div class="price__badges price__badges--listing">';
		if(!data.available) {
			priceHtml += '<span class="price__badge price__badge--sold-out">' +	boostPFSConfig.label.sold_out + '</span>';
		} else {
			if (onSale) {
				priceHtml += '<span class="price__badge price__badge--sale" aria-hidden="true">'+boostPFSConfig.label.sale+'<span>';
			} else if (data.tags.includes('new')) {
				priceHtml += '<span class="price__badge price__badge--new">New</span>';
			}
		}
		priceHtml += '</div></dl>';
		priceHtml += '';
		return priceHtml;
	}

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Build page items
		var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		$('.products-count').html(data.total_product);
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
		if($('.content-tab').length && $('.paginate-items').length){
			if( data.total_product == 0 && parseInt( $('.paginate-items').html() ) > 0 ){
				$('.content-tab').addClass('active');
				$('.product-tab').remove();
				$('.search-products').hide();
				$('.search-content').show();
				$('.boost-pfs-filter-top-sorting').hide();
				$('.boost-pfs-filter-tree-mobile-button').hide();
			}
		}
		document.querySelectorAll('.swatch').forEach(s => {
			s.addEventListener('click', function (e) {
				var img = $(e.target).attr('data-srcset');
				$(e.target).closest('.product-card').find('.media img').attr('srcset', img)
				$(e.target).closest('.product-card').find('a').attr('href', $(e.target).attr('data-url'));
			});
		});
		$('.boost-pfs-filter-load-more-button').addClass('button button--sand-outline').html('Show More');
		$('.js-boost-pfs-filter-btn-load-previous-page').addClass('button button--sand-outline');
		var filterNameChange = setInterval(function () {
			if ($('.boost-pfs-filter-tree-mobile-button button').length > 0) {
				clearInterval(filterNameChange);
				$('.boost-pfs-filter-tree-mobile-button button').html(' Filter');
			}
		}, 100);

		jQ('.boost-total-product').html(data.total_product);

		var editMobileFilters = setInterval(function () {
			if ($('button.boost-pfs-filter-option-title-heading').length > 0) {
				clearInterval(editMobileFilters);
				var selected_collection = $('.boost-pfs-filter-option-collection .boost-pfs-filter-option-item.selected .boost-pfs-filter-option-value').text();
				if (selected_collection && selected_collection.length > 0) {
					$('.collection__title').html(selected_collection);
				}
			}
		}, 100);
	};

	FilterTree.prototype.getFooterTemplate = function() {
		return `
			<div class="boost-pfs-filter-mobile-footer">
				<button class="{{class.showResultFilterButton}}" type="button">{{label.showResult}} (<span class="boost-total-product">{{totalProduct}}</span>)</button>
			</div>
		`.trim();
	}

	var compileTemplate = FilterTree.prototype.compileTemplate;
	FilterTree.prototype.compileTemplate = function() {
		var template = compileTemplate.call(this);

		template = template.replace(/{{totalProduct}}/g, this.parent.data.total_product);
		return template;
	}
})();